import React from 'react';
import InlineEditableField from './InlineEditableField';
import { Typography, Icon } from '../../kit';
import { PROFILE_FIELDS, KYC_ICONS, KYC_STATUS, USER_TYPES } from './config';
import {
  validateBusinessName,
  validateBusinessGstinPan,
  validateBusinessAddress,
} from './validations';
import { themeColors as defaultThemeColors } from '../../theme/theme';
import { useTranslation } from '@/kit/useTranslation';

function BusinessFields({ user, userTypeDetails, onFieldSave, themeColors = {}, loading, error }) {
  const tc = { ...defaultThemeColors, ...themeColors };
  const { t } = useTranslation();
  const getKycIcon = (status) => {
    return KYC_ICONS[status] || KYC_ICONS[KYC_STATUS.FAILED];
  };

  // Show business fields when user type is BUSINESS
  if (userTypeDetails !== USER_TYPES.BUSINESS) return null;

  if (loading?.businessFields) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Typography
          type="body2"
          text={t('profile.loadingBusinessFields')}
          style={{ color: tc.profileMuted }}
        />
      </div>
    );
  }

  return (
    <>
      <InlineEditableField
        label={t(PROFILE_FIELDS.BUSINESS_NAME.labelKey)}
        value={user.businessName}
        validate={validateBusinessName}
        onSave={(val) => onFieldSave('businessName', val)}
      />
      <InlineEditableField
        label={t(PROFILE_FIELDS.BUSINESS_GSTIN.labelKey)}
        value={user.businessGstinPan}
        validate={validateBusinessGstinPan}
        onSave={(val) => onFieldSave('businessGstinPan', val)}
      />
      <InlineEditableField
        label={t(PROFILE_FIELDS.BUSINESS_ADDRESS.labelKey)}
        value={user.businessAddress}
        validate={validateBusinessAddress}
        onSave={(val) => onFieldSave('businessAddress', val)}
      />

      {/* KYC Status with icon */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          borderBottom: `1px solid ${tc.profileBorder}`,
          padding: '12px 0',
        }}
      >
        <Typography
          type="body1"
          text={t(PROFILE_FIELDS.KYC_STATUS.labelKey)}
          style={{ flex: 1, color: tc.profileText, fontWeight: 500 }}
        />
        <div
          style={{
            flex: 2,
            marginLeft: 12,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <Typography
            type="body2"
            text={user.kycStatus || '-'}
            style={{ color: tc.profileMuted }}
          />
          <Icon
            name={getKycIcon(user.kycStatus).name}
            style={{ color: getKycIcon(user.kycStatus).color, fontSize: 22 }}
          />
        </div>
        <Icon
          name="EditOutlined"
          style={{
            color: tc.primaryColor,
            fontSize: 20,
            cursor: 'pointer',
            marginLeft: 12,
          }}
          onClick={() => {
            /* Handle KYC edit */
          }}
        />
      </div>
    </>
  );
}

export default BusinessFields;
